import React from 'react';
import styled from 'styled-components';
import PropTypes from 'prop-types';
import theme from 'fe-appdir-lib-theme';
import LegacyLogo from './LegacyLogo';

const LOGO_WIDTH = 142;
const LOGO_HEIGHT = 45;
const LOGO_WIDTH_MOBILE = 94;
const LOGO_HEIGHT_MOBILE = 30;
const PROP_TYPES = {
  title: PropTypes.string,
  width: PropTypes.number,
  height: PropTypes.number,
  className: PropTypes.string,
  mobileMq: PropTypes.string,
  mobileWidth: PropTypes.number,
  mobileHeight: PropTypes.number,
  isLegacyLogo: PropTypes.bool,
};
const DEFAULT_PROPS = {
  title: 'Hootsuite Apps',
  width: LOGO_WIDTH,
  height: LOGO_HEIGHT,
  mobileMq: `max-width: ${theme.breakpointMobileNav}`,
  mobileWidth: LOGO_WIDTH_MOBILE,
  mobileHeight: LOGO_HEIGHT_MOBILE,
  isLegacyLogo: false,
};

// TODO: update the theme to have the new colors
const Logo = styled.h1`
  font-size: 26px;
  color: #012b3a;
  font-family: 'Montserrat Alternates', sans-serif;

  ${(p) =>
    Boolean(p.mobileMq)
      ? `@media (${p.mobileMq}) {
          font-size: 22px;
        }`
      : null}
`;

const AppLogo = (props) => {
  const { isLegacyLogo } = props;

  if (isLegacyLogo) {
    return <LegacyLogo {...props} />;
  }

  return <Logo {...props}>Hootsuite Apps</Logo>;
};

AppLogo.propTypes = PROP_TYPES;
AppLogo.defaultProps = DEFAULT_PROPS;

export default AppLogo;
